import { Card, Banner, Button, Text, BlockStack } from '@shopify/polaris';
import React from 'react';
import AppUnderMaintainence from '../../../Asests/Images/construction.gif'
import { DI, DIProps } from '../../../Core';
interface Props extends DIProps { }
interface Props extends DIProps {
    maintenanceData?: any;
}
const MaintenancePage = (props: Props) => {
    return (
        <div style={{ padding: '0 20px', marginTop: "20px" }}>
            <Card roundedAbove='sm'>
                <BlockStack inlineAlign="center" gap="100">
                    <img src={AppUnderMaintainence} alt='App not connected' height={400} width={400} />
                    <Text as='h2' variant='headingMd'>App Under Maintenance</Text>
                    <Banner tone='warning'>
                        {(props?.maintenanceData?.['data']?.['date'] && props?.maintenanceData?.['data']?.['time']) ? `Our app is temporarily down for maintenance, aimed at elevating your selling experience. We'll be back up by ${props?.maintenanceData?.['data']?.['date']} at ${props?.maintenanceData?.['data']?.['time']} IST. Rest assured, order and inventory sync remain unaffected. For inquiries, connect with us at` : "Our app is temporarily down for maintenance, aimed at elevating your selling experience. Rest assured, order and inventory sync remain unaffected. For inquiries, connect with us at"} <Button variant="plain" onClick={() => {
                            window.open(`mailto:support@cedcommerce.com?subject=${encodeURIComponent(`${props?.di?.globalState?.get("username") ?? props?.redux?.current?.source?.name ?? "Seller"} has a question about ${process.env.REACT_APP_NAME_AND_ENV ?? "Cedcommerce Amazon Channel"}`)}`);
                        }}>support@cedcommerce.com</Button>
                    </Banner>
                </BlockStack>
            </Card>
        </div>
    );
};
export default DI(MaintenancePage);